import HeadTittle from "../../../components/HeadTittle";
import StepperTabs from "../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../components/StepperTabs/StepTab";
import SectionAccessUserTab from "./SubComponents/SectionAccessUserTab";
import SectionAccessVehicleTab from "./SubComponents/SectionAccessVehicleTab";
import {AccessApp} from "./Funtiomallity/AccessApp";
import {permissionObj} from "../../../Helpers/permission";
import SearchFilterBtn from "../../../components/buttons/SearchFilterBtn";
import React from "react";
import SearchFor from "../../Modals/SearchFor";
import ExportDataBtn from "../../../components/buttons/ExportDataBtn";
import routes from "../../../Routes/routes";
import CustomExpandImage from "../../../components/CustomExpandImage";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * @returns {JSX.Element}
 * @constructor
 */

const Access = () => {

    const {
        DEV, permission,
        navigate,
        steps,
        setActiveStep,
        handleStepChange,
        activeStep,
        filterDialogShow,
        setFilterDialogShow,
        bodyForExport,
        setBodyForExport,
        moduleId,
        option,
        criteria,
        setCriteria,
        search,
        setSearch,
        finalArray,
        setFinalArray,
        searchResults,
        setSearchResults,
        modified,
        setModified,
        searchElement,
        setSearchElement,
        setSimpleSearch,
        contractorId,
        supplierId,
        expandImage, setExpandImage
    } = AccessApp();

    if(!DEV && !permission?.includes(permissionObj.WEB_ACCESS_USER_READ) && !permission?.includes(permissionObj.WEB_ACCESS_VEHICLE_READ)) navigate(routes.forbidden);

    return (
        <div>
            <HeadTittle name={'access'}>
                {(DEV ||
                    (permission?.includes(permissionObj?.WEB_ACCESS_USER_EXPORT) && activeStep === 0) ||
                    (permission?.includes(permissionObj?.WEB_ACCESS_VEHICLE_EXPORT) && activeStep === 1)) &&
                (search ? (
                    <ExportDataBtn
                        moduleId={moduleId}
                        body={criteria}
                        search={search}
                        option={option}
                    />
                ) : (
                    <ExportDataBtn
                        moduleId={moduleId}
                        body={bodyForExport}
                        option={option}
                        search={search}
                    />
                ))}
                <SearchFilterBtn finalArray={finalArray} fnclick={() => setFilterDialogShow(true)} />
            </HeadTittle>

            <StepperTabs onlyTab={true}
                         disabled={false}
                         steps={steps}
                         activeStep={activeStep}
                         isStepOptional={() => { }} setActiveStep={setActiveStep}
                         handleStepChange={handleStepChange}>

                <StepTab index={0} activeStep={activeStep}>
                    {activeStep === 0 && (
                      <>
                          <SectionAccessUserTab
                              setBodyForExport={setBodyForExport}
                              setCriteria={setCriteria}
                              finalArray={finalArray}
                              setSearchResults={setSearchResults}
                              searchResults={searchResults}
                              searchElement={searchElement}
                              setSearchElement={setSearchElement}
                              modified={modified}
                              setModified={setModified}
                              option={option}
                              search={search}
                              setSearch={setSearch}
                              setSimpleSearch={setSimpleSearch}
                              contractorId={contractorId}
                              supplierId={supplierId}
                              expandImage={expandImage}
                              setExpandImage={setExpandImage}
                          />
                      </>
                    )}
                </StepTab>
                <StepTab index={1} activeStep={activeStep}>
                    {activeStep === 1 && (
                        <>
                            <SectionAccessVehicleTab
                                setBodyForExport={setBodyForExport}
                                setCriteria={setCriteria}
                                finalArray={finalArray}
                                modified={modified}
                                setModified={setModified}
                            />
                        </>
                    )}
                </StepTab>
            </StepperTabs>

            <SearchFor
                open={filterDialogShow}
                onClose={() => {
                    setFilterDialogShow(false);
                }}
                onFiltered={(originalArray) => {
                    setFilterDialogShow(false);
                    setFinalArray(originalArray);
                    setSearchElement(''); // Clear search input after filtering
                }}
                moduleId={moduleId}
                option={option}
                finalArray={finalArray}
                cleanAdvance={modified}
                setCleanAdvance={setModified}
                search={search}
                setSearch={setSearch}
                setFinalArray={setFinalArray} // Used to reset filters
                searchElement={searchElement} // Track input changes
            />
            <CustomExpandImage expandImage={expandImage} setExpandImage={setExpandImage}/>
        </div>
    );
};

export default Access;
